import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookiesConsentService {

  constructor() { }
  initCookiesConsent(): void {
    const consent = localStorage.getItem('clairtyAnalyticsConsent');
    if (consent == null) {
      localStorage.setItem('clairtyAnalyticsConsent', 'true');
    }
    else if (consent === 'true') {
      this.startClarity();
    }
  }
  acceptCookies(): void {
    localStorage.setItem('clairtyAnalyticsConsent', 'true');
    this.startClarity();
  }

  rejectCookies(): void {
    localStorage.setItem('clairtyAnalyticsConsent', 'false');
    this.withdrawConsent();
  }
  getConsentStatus(): boolean {
    const consent = localStorage.getItem('clairtyAnalyticsConsent');
    if (consent == null) {
      return true;
    }
    return consent === 'true';
  }

  private startClarity(): void {
    // Microsoft Clarity snippet
    (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
           t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
           y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); 
              })(window, document, "clarity", "script", "t90p25u4k9");

    // Explicit consent signal
    (window as any).clarity("consent");
  }
  withdrawConsent(): void {
    localStorage.setItem('analyticsConsent', 'false');
    const clarityScript = document.querySelector('script[src*="clarity.ms"]');
    if (clarityScript) {
      clarityScript.remove();
    }
  
    delete (window as any).clarity;
  }
}
